import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getCustomerWalletProfiles } from 'services/CustomerService'
import { GetCustomerWalletProfilesRequest } from 'types/customers'

export const useGetCustomersWalletProfileQuery = (request?: GetCustomerWalletProfilesRequest) => {
  return useQuery({
    queryKey: reactQueryKeys.customerWalletProfiles(request),
    queryFn: () => getCustomerWalletProfiles(request),
  })
}
